import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PanicButton from "@/components/PanicButton";

export default function AppLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 em-noise flex flex-col">
      <Navbar />
      <div className="pt-16 lg:pt-20 flex-1">
        <Outlet />
      </div>
      <Footer />
      <PanicButton />
    </div>
  );
}
